import { throttle } from '@tencent/qd-lib';
import axios from 'axios';
import { GET_CONSULT_FORM_DETAIL, SUBMIT_CONSULT_FORM, BEFORE_CONSULT_SKIP } from '@/utils/api';


export default {
  props: {
    formParams: {
      type: Object,
      default() {
        return {};
      },
    },
    source: '',
    requestDomain: '',   // 请求域名
  },
  data() {
    return {
      // 是否显示表单
      openPop: false,
      // 表单数据
      data: {
        content: [],
        isAgree: false,

      },
    };
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  mounted() {
    this.getInformationData();
  },
  methods: {
    /**
     * 展开表单，带参数初始化表单内容
     * @param {*} params
     */
    show(params) {
      setTimeout(() => {
        this.openPop = true;
      }, 400);
      const { formId = '', grayMsgSeq = '', uk = '', isPre = false } = params;
      // 表单ID
      this.formId = formId;
      // 跟表单关联的那条灰条消息的Seq
      this.connectionGrayMsgSeq = grayMsgSeq;
      // 后端透传的特征值
      this.uk = uk;
      // 是否询前
      this.isPre = isPre;
      // 获取表单内容信息
      this.getInformationData();
    },
    /**
     * 获取表单内容信息
     */
    getInformationData() {
      const { channelID, custID, formId, isPre, kfext, uk, wpaId } = this.formParams;
      const params = {
        channelID,
        custID,
        isPre: !!isPre,
        kfext,
        wpaId,
      };
      if (uk) {
        params.uk = uk;
      } else {
        params.formId = formId;
      }
      axios.post(`${this.requestDomain}${GET_CONSULT_FORM_DETAIL}`,  this.formParams, {
        headers: {
          'X-Tenant-Id': this?.formParams.kfuin,
        },
      })
        .then((res) => {
          const { code, data } = res.data;
          if (+code === 0) {
            this.$emit('updateFormTitle', data.title);
            if (data.show) {
              this.$emit('repeatForm');
            }
            this.data = this.preHandleFormData(data);
            this.$nextTick(() => {
              this.setFormMargin();
            });
          } else {
            this.$Toast('获取表单信息失败');
            setTimeout(() => {
              this.hide();
            }, 500);
          }
        })
        .catch((error) => {
          this.$Toast('获取表单信息失败');
          console.error('获取表单_catch', error);
          setTimeout(() => {
            this.hide();
          }, 500);
        });
    },

    /**
     * 处理提交逻辑
     */
    handleSubmit: throttle(async function () {
      // 校验表单内容
      if (!this.checkSubmitContent()) {
        return;
      }
      if (this.data.hasAgreement && !this?.data?.isAgree) {
        this.$Toast('请阅读并同意相关协议条款');
        return;
      }
      const submitData = this.preHandleSubmitData();
      console.log('submitData', submitData);
      const params = {
        content: submitData || this.data.content,
        ...this.formParams,
      };
      axios.post(`${this.requestDomain}${SUBMIT_CONSULT_FORM}`, params, {
        headers: {
          'X-Tenant-Id': this?.formParams?.kfuin,
        },
      })
        .then((res) => {
          const { code, msg } = res.data;
          if (+code === 0) {
            this.$emit('onFormSubmit', { submitData });
          } else {
            this.$Toast(msg || '表单信息提交失败');
          }
        })
        .catch((e) => {
          this.$Toast('表单信息提交失败');
          console.error('表单信息提交_catch', e);
        });
    }, 500),

    /**
     * 提交之前预处理，为了不影响本地渲染，拷贝一下对象
     * @returns
     */
    preHandleSubmitData() {
      const submitData = this.data.content.map((element) => {
        try {
          const item = JSON.parse(JSON.stringify(element));
          if (element.type === 8) {
            item.value = JSON.stringify(item.value || []);
            return item;
          }
          return element;
        } catch {
          return element;
        }
      });
      return submitData;
    },
    // 跳过
    handleSkip() {
      axios.post(`${this.requestDomain}${BEFORE_CONSULT_SKIP}`, {
        isPre: true, // 是否询前。1-是
        uk: this?.formParams?.uk,
      }, {
        headers: {
          'X-Tenant-Id': this?.formParams?.kfuin,
        },
      });
      this.$emit('skipForm');
    },
    // 隐藏弹窗
    hide() {
      this.openPop = false;
    },

    /**
     * 校验表单内容
     * @param {*} item
     * @param {*} index
     */
    checkFormItem(item, index) {
      if (item.required && !item.value) {
        this.$set(this.data.content[index], 'error', `${item.name}不能为空`);
        return false;
      }
      this.$set(this.data.content[index], 'error', '');
      return true;
    },
    checkSubmitContent() {
      const content = this?.data?.content || [];
      const { length } = content;
      for (let i = 0; i < length;i++) {
        if (!this.checkFormItem(content[i], i)) {
          return false;
        }
      }
      return true;
    },
    focus(item, index) {
      this.$set(this.data.content[index], 'isFocus', true);
    },
    blur(item, index) {
      setTimeout(() => {
        this.$set(this.data.content[index], 'isFocus', false);
      }, 500);

      this.checkFormItem(item, index);
    },
    // 清除文本内容
    clearText(item, index) {
      this.data.content[index].value = '';
    },
    // 渲染之前预处理
    preHandleFormData(data) {
      data.content.forEach((item) => {
        try {
          if (item.type === 8) {
            const choosedArray = item.value ? JSON.parse(item.value) : [];
            // PC端 原生多选接收数组，H5 vant需要字符串，渲染使用
            item.value = choosedArray;
            item.text = choosedArray.join(',');
          }
          const OptionsTypes = [6, 7, 8];
          // 单选、多选要处理一下键名，以接入H5公共选择组件
          if (OptionsTypes.includes(item.type)) {
            item.options = this.transferFormOptions(item.options);
          }
          // 处理回显
          item.text = this.handleOptionsReplay(item);
        } catch (e) {
          console.log('preHandleFormData_catch', e);
        }
      });
      this.$set(data, 'isAgree', false);
      return data;
    },
    /**
     * 勾选/取消勾选协议条款
     */
    switchAgreement() {
      this.$set(this.data, 'isAgree', !this.data.isAgree);
    },
    /**
     * 处理选项
     * @param {*} list
     * @returns
     */
    transferFormOptions(list = []) {
      return list.map(item => ({
        text: item.value,
        value: item.key,
      }));
    },
    setFormMargin() {
      try {
        const formContainerEl = document.querySelector('.form-container');
        const footerEl = document.querySelector('.form-footer');
        const footerHeight = footerEl.offsetHeight;
        formContainerEl.style.marginBottom = `${footerHeight - 15}px`;
      } catch (e) {
        console.error('setFormMargin_catch', e);
      }
    },
    /**
     * 回显处理
     */
    handleOptionsReplay(item) {
      const { type } = item;
      switch (+type) {
        case 4:
          return item.value;
        case 6:
        case 7: {
          const option = item.options.find(element => element.value === item.value);
          return option ? option.text : '';
        }
        default:
          return item.text || '';
      }
    },
  },
};
